import React from "react";
import { Link } from "react-router-dom";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import Crousel from "../component/Crousel";
import { useState } from "react";
import { useEffect } from "react";
import { collection, onSnapshot, query } from "firebase/firestore";
import { db } from "../firebase";
import NavbarComponent from "../component/NavbarComponent";
import { motion } from "framer-motion";

export const HomePage = () => {
  const [noticeNews, setNoticeNews] = useState([]);
  const [tenthToper, setTenthToper] = useState([]);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    const q = query(collection(db, "toperStudents"));
    onSnapshot(q, (querySnapshot) => {
      let filesArry = [];
      querySnapshot.forEach((doc) => {
        filesArry.push({ id: doc.id, ...doc.data() });
      });
      setTenthToper(filesArry);
    });
  }, []);

  let tenthArr = [];
  tenthArr = tenthToper?.filter((item) => item?.classStream === "10th");

  let twelvethArrArts = [];
  twelvethArrArts = tenthToper?.filter(
    (item) => item?.classStream === "12th Arts"
  );

  let twelvethArrCommerce = [];
  twelvethArrCommerce = tenthToper?.filter(
    (item) => item?.classStream === "12th Commerce"
  );

  let twelvethArrScience = [];
  twelvethArrScience = tenthToper?.filter(
    (item) => item?.classStream === "12th Science"
  );

  useEffect(() => {
    const q = query(collection(db, "noticeAll"));
    onSnapshot(q, (querySnapshot) => {
      let noticeArray = [];
      querySnapshot.forEach((doc) => {
        noticeArray.push({ id: doc.id, ...doc.data() });
      });
      setNoticeNews(noticeArray);
    });
  }, []);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDyCtLgVFmT4WecAhz5h0waAGHDUIo7qKQ",
  });
  if (!isLoaded) return <div></div>;
  const onLoadMarker = (Marker) => {};

  // const handleMouseEnter = () => {
  //   setHover(true);
  // };

  // const handleMouseLeave = () => {
  //   setHover(false);
  // };

  // style={{

  //   backgroundColor: hover ? 'yellow' : '#fff',
  //   color: hover ? 'black' : 'white',
  //   fontWeight: 'bold',
  //   textAlign: 'center',
  // }}
  // onMouseEnter={handleMouseEnter}
  // onMouseLeave={handleMouseLeave}

  return (
    <React.Fragment>
      <NavbarComponent />
      {/* marquee start */}
      <div className="bg-[#efebeb]   h-12">
        <marquee direction="left" scrollamount="6">
          <div className="flex flex-row items-center">
            <img src="../assets/new.gif" alt="gif" className="h-12 w-12" />
            <h1 className="text-black text-xl font-semibold ">
              From April 2022 there is no fee Charges for girl child
            </h1>
            <img src="../assets/new.gif" alt="gif" className="h-12 w-12" />
            <h1 className="text-black text-xl font-semibold ">
              Students are asked to procure textbooks as per latest publication
              of CBSE/NCERT
            </h1>
            <img src="../assets/new.gif" alt="gif" className="h-12 w-12" />
            <h1 className="text-black text-xl font-semibold ">
              Students from class 8 and 9, boys and girls both those who desire
              to join NCC should contact ANO in the third week of April 2023.
            </h1>
          </div>
        </marquee>
      </div>
      {/* marquee end */}

      {/* Crousel start */}
      <div className="">
        <Crousel />
      </div>
      {/* Crousel end */}

      {/* Academics Section start */}
      <div className="lg:pl-20 md:pl-20">
        <div className="p-1 lg:grid lg:grid-cols-2 lg:gap-x-4 sm:grid-row-2 md:grid md:grid-cols-2 gap-4">
          <div className=" text-lg  text-left p-5 lg:p-10  rounded-lg  row-span-2 ">
            <h2 className="text-2xl  text-indigo-600 font-bold">
              Academics & Facilities
            </h2>
            <div className="grid grid-cols-2 mt-4 ">
              <motion.div
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: -100 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                viewport={{ once: true }}
                className=" bg-[#334d4d] text-lg  text-left py-2  mb-2 rounded-lg col-span-2 "
              >
                <span className="text-md font-bold  ml-2  text-white">
                  Curriculum & Syllabus:
                </span>
                <br />
                <span className="text-sm ml-2 text-white">
                  Class 9-12 as per CBSE. Academic Calendar.
                </span>
              </motion.div>
              <motion.div
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: -100 }}
                transition={{ duration: 1, delay: 1 }}
                viewport={{ once: true }}
                className=" bg-[#000080] text-[#ffffff]  text-left p-2 mr-2 rounded-lg "
              >
                <h5 className="font-bold">Science</h5>
                <p className="text-sm">
                  English Core, Hindi Core, Sanskrit Core, Physics, Chemistry,
                  Mathematics , Physical Education & Music
                </p>
              </motion.div>
              <motion.div
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: -100 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                viewport={{ once: true }}
                className=" bg-[#39004d] text-[#ffffff]  text-left p-2  ml-2 rounded-lg "
              >
                <h5 className="font-bold">Arts</h5>
                <p className="text-sm">
                  English Core, Hindi Core, Sanskrit Core, History, Sociology,
                  Political Science , Physical Education & Music
                </p>
              </motion.div>
              <motion.div
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: -100 }}
                transition={{ duration: 1, delay: 1 }}
                viewport={{ once: true }}
                className="bg-[#ff6600] text-[#ffffff]  text-left p-2 mt-2 mr-2 rounded-lg "
              >
                <h5 className="font-bold">Commerce</h5>
                <p className="text-sm">
                  English Core, Hindi Core, Sanskrit Core, Accountancy, Business
                  Studies , Economics , Physical Education & Music
                </p>
              </motion.div>
              <motion.div
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: -100 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                viewport={{ once: true }}
                className="bg-[#103b1a] text-[#ffffff]  text-left p-2 mt-2 ml-2 rounded-lg "
              >
                <h5 className="font-bold">Sports & Games</h5>
                <p className="text-sm">
                  Cricket, Football, Volleball, Kho-Kho, Kabaddi, Badminton,
                  Chess, Discuss, Shot Put
                </p>
              </motion.div>
              <motion.div
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: -100 }}
                transition={{ duration: 1, delay: 1 }}
                viewport={{ once: true }}
                className="bg-[#662200] text-[#ffffff] text-left p-2 mt-2 mr-2 rounded-lg  "
              >
                <h5 className="font-bold">NCC</h5>
                <p className="text-sm ">
                  Army wing Troop No.365 JD & JW. Every year 50 Cadets are
                  enrolled for two years course. Eligibility of cadets
                  preferably who are studying in the school from class 8 & 9 and
                  whose age is 13-15 years. 33% female students’ seats are
                  reserved
                </p>
              </motion.div>
              <motion.div
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: -100 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                viewport={{ once: true }}
                className=" bg-[#4f7098] text-[#ffffff]  text-left p-2 mt-2 ml-2 rounded-lg "
              >
                <h5 className="font-bold">Career Counselling</h5>
                <p className="text-sm  ">
                  Every year in second term career counselling is done.
                  Preferably ex-students of the school who are well settled &
                  occupy prestigious post are called to counsell the students.
                  The school management committee decides the counseller.
                  Scholarships: Scholarships are available to BSL employees
                  wards who take admission in technicial field after passing
                  class XII from any school
                </p>
              </motion.div>
            </div>
          </div>

          <div className="text-lg  text-center lg:p-10  pl-5 pr-5 rounded-lg  row-span-2">
            <motion.div
              whileInView={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: 100 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className="lg:mb-8 text-left"
            >
              <h2 className="text-2xl  text-indigo-600 font-bold">About us</h2>
              <p className="text-sm lg:mr-16 mt-4">
                Bokaro Ispat Senior Secondary School, 8B, is an English medium
                co-educational CBSE school. It was established in the year
                1991.This school is directly managed by SAIL, Bokaro Steel Plant
                under its welfare scheme. Besides the wards of steel plant
                employees, children from under-privileged families of the local
                populace form a large part of its student population. Some
                students from far-off places also prefer to read in this school
                staying in hostels or with relatives.
              </p>
              <p className="text-sm mt-2 lg:mr-16 ">
                The school facilitates science, commerce and arts streams in
                classes XI and XII. Affiliated to CBSE it has set its mission on
                'all round development' of students by creating an affable
                learning environment in the campus. Apart from academics, the
                school emphasizes on personality development too. It is a matter
                of great pleasure that now-a-days CBSE has also included value
                based education in its curriculum
                <Link to={"/aboutUs"}>
                  <span className="text-blue-700 ml-2 text-base hover:text-blue-700 hover:text-lg">
                    view more...
                  </span>
                </Link>
              </p>
              <div className="grid grid-cols-2 gap-4 mt-3">
                <motion.div
                  whileInView={{ opacity: 1, x: 0 }}
                  initial={{ opacity: 0, x: 100 }}
                  transition={{ duration: 0.75, delay: 0.75 }}
                  viewport={{ once: true }}
                  className=" text-blue-700  text-left  rounded-lg"
                >
                  <h4 className="font-bold">SMC Chairman:</h4>
                  <img
                    src="../assets/gm-edu-img.jpg"
                    alt="pic"
                    className="h-48 w-48 object-cover"
                  />
                  <span className="text-black">Smt. Meenam Mishra</span>
                </motion.div>
                <motion.div
                  whileInView={{ opacity: 1, x: 0 }}
                  initial={{ opacity: 0, x: 100 }}
                  transition={{ duration: 0.75, delay: 0.75 }}
                  viewport={{ once: true }}
                  className=" text-blue-700  text-left  rounded-lg"
                >
                  <h4 className="font-bold">Principal:</h4>
                  {/* <img src="../assets/DSC_5012.jpg" alt="pic" className="h-32 w-48" /> */}
                  <span className="text-black">Shri. Shiv Shankar Yadav </span>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
      {/* Academics Section end */}

      {/* News start */}
      <div className="lg:grid lg:grid-cols-2 lg:gap-4 lg:pl-32 lg:pr-32 h-64">
        <div className="">
          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: -100 }}
            transition={{ duration: 0.75, delay: 0.75 }}
            viewport={{ once: true }}
            className="bg-[#033f63] py-2 text-center font-bold text-white text-xl"
          >
            News & Events
          </motion.div>
          <div className="text-center ">
            <table className="mx-auto">
              <tbody>
                {noticeNews?.map((item, index) => (
                  <tr className="text-center" key={index}>
                    <td className="hidden">{++index}</td>
                    <motion.td
                      whileInView={{ opacity: 1, y: 0 }}
                      initial={{ opacity: 0, y: 100 }}
                      transition={{ duration: 0.75, delay: 0.75 }}
                      viewport={{ once: true }}
                      className="py-2 text-xl px-10  font-bold text-gray-900"
                    >
                      <Link
                        to="../noticePeople"
                        state={{ noticePeopleId: item.id }}
                      >
                        {item.noticeTitle}
                      </Link>
                    </motion.td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="">
          <motion.div
            whileInView={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.75, delay: 0.75 }}
            viewport={{ once: true }}
            className="bg-[#033f63]  w-full py-2 text-center font-bold text-white text-xl"
          >
            Important Links
          </motion.div>
          <div className=" text-center">
            <motion.div
              whileInView={{ opacity: 1, y: 0 }}
              initial={{ opacity: 0, y: 100 }}
              transition={{ duration: 0.75, delay: 0.75 }}
              viewport={{ once: true }}
              className="bg-[#fb8500] py-2 text-center font-bold text-white mt-5 w-80 mx-auto rounded-lg"
            >
              <span>Announcements</span>
            </motion.div>
            <Link to="../holidaysList">
              <motion.div
                whileInView={{ opacity: 1, y: 0 }}
                initial={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.75, delay: 0.75 }}
                viewport={{ once: true }}
                className="bg-[#b5b682] py-2 text-center font-bold text-white mt-5 w-80 mx-auto rounded-lg"
              >
                <span>Holidays List</span>
              </motion.div>
            </Link>
            {/* <div className="bg-[#118ab2] py-2 text-center font-bold text-white mt-5 w-80 mx-auto rounded-lg">
              <span>Facilitates</span>
            </div> */}
          </div>
        </div>
      </div>
      {/* News end */}

      {/* Testimonail  Start */}
      {/* <div className="relative z-10 bg-slate-50 mt-4">
      <div className="lg:pt-10  px-32 opacity-100">
        <div className="mb-8 text-center">
          <h2 className="text-4xl  text-indigo-600">
            What others say about us
          </h2>
          <p className="text-lg text-gray-600">What others say about us</p>
        </div>
        <div className="lg:grid lg:grid-cols-2 lg:gap-x-4 lg:pl-32 lg:pr-32 mt-12">
        <div className="p-4 text-gray-800 h-64 rounded-lg shadow-md bg-white col-span-2">
            <div className="mb-2 ">
              <div className="flex flex-col items-center justify-center -mt-16">
                <div className="w-32 h-32 overflow-hidden bg-gray-100 border-b-4 border-r-2 border-l-1 border-slate-400 rounded-full">
                  <img
                    src="https://cdn.pixabay.com/photo/2017/05/19/12/38/entrepreneur-2326419__340.jpg"
                    alt="img"
                    className="object-cover object-center w-full h-full"
                  />
                </div>
                <h5 className=" text-indigo-600">John Doe</h5>
                <p className="text-sm text-gray-600">CEO / Founder</p>
              </div>
              <p className="mt-6 text-center text-gray-600 ">
                " Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Similique sapiente iusto esse. "
              </p>
            </div>
          </div>
          <div className="p-4 text-gray-800 rounded-lg shadow-md bg-white mt-16">
            <div className="mb-2">
              <div className="flex flex-col items-center justify-center -mt-16">
                <div className="w-32 h-32 overflow-hidden bg-gray-100 border-b-4 border-r-2 border-l-1 border-slate-400 rounded-full">
                  <img
                    src="https://cdn.pixabay.com/photo/2021/07/14/17/32/manager-6466713__340.jpg"
                    alt="img"
                    className="object-cover object-center w-full h-full"
                  />
                </div>
                <h5 className=" text-indigo-600">michael james</h5>
                <p className="text-sm text-gray-600">web developer</p>
              </div>
              <p className="mt-6 text-center text-gray-600 ">
                " Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Similique sapiente iusto esse. "
              </p>
            </div>
          </div>
          <div className="p-4 text-gray-800 rounded-lg shadow-md bg-white mt-16">
            <div className="mb-2">
              <div className="flex flex-col items-center justify-center -mt-16">
                <div className="w-32 h-32 overflow-hidden bg-gray-100 border-b-4 border-r-2 border-l-1 border-slate-400 rounded-full">
                  <img
                    src="https://cdn.pixabay.com/photo/2021/07/14/17/32/manager-6466713__340.jpg"
                    alt="img"
                    className="object-cover object-center w-full h-full"
                  />
                </div>
                <h5 className=" text-indigo-600">michael james</h5>
                <p className="text-sm text-gray-600">web developer</p>
              </div>
              <p className="mt-6 text-center text-gray-600 ">
                " Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Similique sapiente iusto esse. "
              </p>
            </div>
          </div>
        </div>
      </div>
      </div> */}
      {/* Testimonail  End */}

      {/* Gallery Section Start */}
      <section className="overflow-hidden mt-20 md:mt-10 text-gray-700">
        <div className="container px-5 py-2 mx-auto lg:pt-10 lg:px-32 ">
          <h1 className="lg:text-4xl text-2xl mb-6 text-center ">Gallery</h1>
          <div className="lg:flex lg:flex-wrap -m-1 md:-m-2 ">
            <div className="flex flex-wrap lg:w-1/2">
              <motion.div
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: -100 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                viewport={{ once: true }}
                className="w-1/2 p-1 md:p-2"
              >
                <img
                  alt="gallery"
                  className="block object-cover object-center w-full h-full rounded-lg"
                  src="../assets/house_2247.JPG"
                />
              </motion.div>
              <motion.div
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: -100 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                viewport={{ once: true }}
                className="w-1/2 p-1 md:p-2"
              >
                <img
                  alt="gallery"
                  className="block object-cover object-center w-full h-full rounded-lg"
                  src="../assets/house_5562.JPG"
                />
              </motion.div>
              <motion.div
                whileInView={{ opacity: 1, y: 0 }}
                initial={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.75, delay: 0.75 }}
                viewport={{ once: true }}
                className="w-full p-1 md:p-2"
              >
                <img
                  alt="gallery"
                  className="block object-cover object-center w-full h-full rounded-lg"
                  src="../assets/house_2303.JPG"
                />
              </motion.div>
            </div>
            <div className="flex flex-wrap lg:w-1/2">
              <motion.div
                whileInView={{ opacity: 1, y: 0 }}
                initial={{ opacity: 0, y: -100 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                viewport={{ once: true }}
                className="w-full p-1 md:p-2"
              >
                <img
                  alt="gallery"
                  className="block object-cover object-center w-full h-full rounded-lg"
                  src="../assets/house_2306.JPG"
                />
              </motion.div>
              <motion.div
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                viewport={{ once: true }}
                className="w-1/2 p-1 md:p-2"
              >
                <img
                  alt="gallery"
                  className="block object-cover object-center w-full h-full rounded-lg"
                  src="../assets/house_5551.JPG"
                />
              </motion.div>
              <motion.div
                whileInView={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.75, delay: 0.75 }}
                viewport={{ once: true }}
                className="w-1/2 p-1 md:p-2"
              >
                <img
                  alt="gallery"
                  className="block object-cover object-center w-full h-full rounded-lg"
                  src="../assets/DSC_5123.jpg"
                />
              </motion.div>
            </div>
          </div>
          <Link to={"/img"}>
            <div className="mt-8 text-center">
              <span className="font-bold text-red-600">View More </span>
            </div>
          </Link>
        </div>
      </section>
      {/* Gallery Section end */}

      {/* <div className="md:flex h-full w-full p-10 items-center justify-center  gap-x-16 md:px-32">
        <div className="group h-96 w-80 [perspective:1000px]">
          <div className="relative h-full w-full rounded-xl shadow-xl transition-all duration-500 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)]">
            <div className="absolute insert-0 h-full w-full">
              <img
                className="h-full w-full rounded-xl shadow-xl object-cover shadow-black/40"
                src="../assets/DSC_5113.jpg"
                alt="pic"
              />
            </div>
            <div className="absolute insert-0 h-full w-full rounded-xl shadow-xl bg-black/80 px-12 text-center text-slate-200 [transform:rotateY(-180deg)] [backface-visibility:hidden] ">
              <div className="flex min-h-full flex-col items-center justify-center">
                <h1 className="text-3xl font-bold">Ashutosh Oraon</h1>
                <p className="text-lg">Designer & developer</p>
                <button className="mt-2 rounded-md py-1 px-2 bg-neutral-800 hover:bg-neutral-900 ">
                  Read more
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="group h-96 w-80 [perspective:1000px]">
          <div className="relative h-full w-full rounded-xl shadow-xl transition-all duration-500 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)]">
            <div className="absolute insert-0 h-full w-full">
              <img
                className="h-full w-full rounded-xl shadow-xl object-cover shadow-black/40"
                src="../assets/DSC_5113.jpg"
                alt="pic"
              />
            </div>
            <div className="absolute insert-0 h-full w-full rounded-xl shadow-xl bg-black/80 px-12 text-center text-slate-200 [transform:rotateY(-180deg)] [backface-visibility:hidden] ">
              <div className="flex min-h-full flex-col items-center justify-center">
                <h1 className="text-3xl font-bold">Ashutosh Oraon</h1>
                <p className="text-lg">Designer & developer</p>
                <button className="mt-2 rounded-md py-1 px-2 bg-neutral-800 hover:bg-neutral-900 ">
                  Read more
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="group h-96 w-80 [perspective:1000px]">
          <div className="relative h-full w-full rounded-xl shadow-xl transition-all duration-500 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)]">
            <div className="absolute insert-0 h-full w-full">
              <img
                className="h-full w-full rounded-xl shadow-xl object-cover shadow-black/40"
                src="../assets/DSC_5113.jpg"
                alt="pic"
              />
            </div>
            <div className="absolute insert-0 h-full w-full rounded-xl shadow-xl bg-black/80 px-12 text-center text-slate-200 [transform:rotateY(-180deg)] [backface-visibility:hidden] ">
              <div className="flex min-h-full flex-col items-center justify-center">
                <h1 className="text-3xl font-bold">Ashutosh Oraon</h1>
                <p className="text-lg">Designer & developer</p>
                <button className="mt-2 rounded-md py-1 px-2 bg-neutral-800 hover:bg-neutral-900 ">
                  Read more
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Toppers Section Start */}
      {/* <div className="container mt-6 ">
        <div className="lg:grid lg:grid-cols-2 lg:mt-10 lg:mb-10 lg:ml-20 lg:mr-20">
          <div className="shadow-lg bg-slate-200 text-lg font-bold text-center p-3 lg:mr-2 mt-4">
            <h2 className="text-2xl mb-2 text-[#000000]">10th Topper</h2>
            <div className="lg:grid lg:grid-cols-3 grid pr-2 grid-cols-2 ">
             {tenthArr?.map((item , index)=>(
              <div key={index} className="shadow-lg bg-[#FFFFFF] text-[#000000] text-lg sm:text-sm font-bold sm:text-center mr-2 ml-2 mb-2 rounded-lg lg:mr-2 lg:ml-2 lg:mt-2 lg:mb-2 transition duration-500 hover:scale-110 hover:bg-white-600">
                <div className="">
                  <div className="hidden">{++index}</div>
                 <img src={item.pictureUrl} alt="pic"  className="w-full h-36 rounded-t-lg"/>
                  <h1 className="text-sm">{item.studentName}</h1>
                  <span className="text-sm">{item.studentPercentage}</span>
                </div>
              </div>
            ))}
            </div>
          </div>
          <div className="shadow-lg bg-slate-200 text-lg font-bold text-center p-3 lg:ml-2 mt-4">
            <h2 className="text-2xl mb-2 text-[#000000] ">12th Science Topper</h2>
            <div className="lg:grid lg:grid-cols-3 grid pr-2 grid-cols-2 ">
          {twelvethArrScience?.map((item , index)=>(
              <div key={index} className="shadow-lg bg-[#FFFFFF]  text-[#000000] text-lg sm:text-sm font-bold sm:text-center mr-2 ml-2 mb-2 rounded-lg lg:mr-2 lg:ml-2 lg:mt-2 lg:mb-2 transition duration-500 hover:scale-110 hover:bg-white-600">
                <div className="">
                  <div className="hidden">{++index}</div>
                 <img src={item.pictureUrl} alt="pic"  className="w-full h-36 rounded-t-lg"/>
                  <h1 className="text-sm">{item.studentName}</h1>
                  <span className="text-sm">{item.studentPercentage}</span>
                </div>
              </div>
                ))}
            </div>
          </div>
       <div className="shadow-lg bg-slate-200 text-lg font-bold text-center p-3 lg:mr-2 mt-4">
       <h2 className="text-2xl mb-2 text-[#000000] ">12th Commerce Topper</h2>
       <div className="lg:grid lg:grid-cols-3 grid pr-2 grid-cols-2 ">
             {twelvethArrCommerce?.map((item , index)=>(
         <div key={index} className="shadow-lg bg-[#FFFFFF] text-[#000000] text-lg sm:text-sm font-bold sm:text-center mr-2 ml-2 mb-2 rounded-lg lg:mr-2 lg:ml-2 lg:mt-2 lg:mb-2 transition duration-500 hover:scale-110 hover:bg-white-600">
           <div className="">
            <div className="hidden">{++index}</div>
            <img src={item.pictureUrl} alt="pic"  className="w-full h-36 rounded-t-lg"/>
             <h1 className="text-sm">{item.studentName}</h1>
             <span className="text-sm">{item.studentPercentage}</span>
           </div>
         </div>
       ))}
       </div>
     </div>
          <div className="shadow-lg bg-slate-200 text-lg font-bold text-center p-3 lg:ml-2 mt-4">
            <h2 className="text-2xl mb-2 text-[#000000] ">12th Arts Topper</h2>
            <div className="lg:grid lg:grid-cols-3 grid pr-2 grid-cols-2 ">
             {twelvethArrArts?.map((item , index)=>(
              <div key={index} className="shadow-lg bg-[#FFFFFF] text-[#000000] text-lg sm:text-sm font-bold sm:text-center mr-2 ml-2 mb-2 rounded-lg lg:mr-2 lg:ml-2 lg:mt-2 lg:mb-2 transition duration-500 hover:scale-110 hover:bg-white-600">
                <div className="">
                  <div className="hidden">{++index}</div>
                 <img src={item.pictureUrl} alt="pic"  className="w-full h-36 rounded-t-lg"/>
                  <h1 className="text-sm">{item.studentName}</h1>
                  <span className="text-sm">{item.studentPercentage}</span>
    
                </div>
              </div>
            ))}
            </div>
          </div>
        </div>
      </div> */}
      {/* Toppers Section end */}

      <div className="">
        <div className="lg:p-20 p-10">
          <h1 className="lg:text-5xl text-2xl font-serif font-bold text-center ">
            Our House System
          </h1>
          <div className="grid md:grid-cols-2 gap-5 lg:pl-40 lg:pr-40 pt-10 relative">
            <motion.div
              whileInView={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: -700 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className="h-80 w-full rounded-xl shadow-xl grid grid-rows-5 group relative overflow-hidden transform transition-all duration-500"
            >
              <div className="row-span-4 bg-blue-600">
                <img
                  src="./assets/birsa-munda.jpg"
                  alt="pic"
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="row-span-1 absolute bottom-0 group-hover:bottom-0 hover:h-full  h-16 w-full transition-all duration-500  bg-white dark:bg-slate-900 rounded-b-xl shadow dark:shadow-gray-700">
                <h1 className="lg:text-4xl text-2xl text-[#623f99] font-serif font-bold mt-2 text-center ">
                  Birsa House
                </h1>
              </div>
            </motion.div>
            <motion.div
              whileInView={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: 700 }}
              transition={{ duration: 0.75, delay: 0.75 }}
              viewport={{ once: true }}
              className="h-80 w-full  rounded-xl shadow-xl grid grid-rows-5 group relative overflow-hidden transform transition-all duration-500"
            >
              <div className="row-span-4 bg-green-600">
                <img
                  src="./assets/rajendra-prasad.jpg"
                  alt="pic"
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="row-span-1 absolute bottom-0 group-hover:bottom-0 hover:h-full  h-16 w-full transition-all duration-500  bg-white dark:bg-slate-900 rounded-b-xl shadow dark:shadow-gray-700">
                <h1 className="lg:text-4xl text-2xl text-[#623f99] font-serif font-bold mt-2 text-center ">
                  Rajendra House
                </h1>
              </div>
            </motion.div>
            <motion.div
              whileInView={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: -700 }}
              transition={{ duration: 0.75, delay: 0.75 }}
              viewport={{ once: true }}
              className="h-80 w-full  rounded-xl shadow-xl grid grid-rows-5 group relative overflow-hidden transform transition-all duration-500"
            >
              <div className="row-span-4 bg-red-600">
                <img
                  src="./assets/shivaji-maharaj.jpg"
                  alt="pic"
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="row-span-1 absolute bottom-0 group-hover:bottom-0 hover:h-full  h-16 w-full transition-all duration-500  bg-white dark:bg-slate-900 rounded-b-xl shadow dark:shadow-gray-700">
                <h1 className="lg:text-4xl text-2xl text-[#623f99] font-serif font-bold mt-2 text-center ">
                  Shivaji House
                </h1>
              </div>
            </motion.div>
            <motion.div
              whileInView={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: 700 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className="h-80 w-full  rounded-xl shadow-xl grid grid-rows-5 group relative overflow-hidden transform transition-all duration-500"
            >
              <div className="row-span-4 bg-yellow-600">
                <img
                  src="./assets/RabindraNath.png"
                  alt="pic"
                  className="h-full w-full object-cover"
                />
              </div>
              <div className="row-span-1 absolute bottom-0 group-hover:bottom-0 hover:h-full  h-16 w-full transition-all duration-500  bg-white dark:bg-slate-900 rounded-b-xl shadow dark:shadow-gray-700">
                <h1 className="lg:text-4xl text-2xl text-[#623f99] font-serif font-bold mt-2 text-center ">
                  Tagor House
                </h1>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      <footer className="text-center  bg-blue-900 text-gray-600">
        <div className=" py-10 text-center">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
            <motion.div
              whileInView={{ opacity: 1, y: 0 }}
              initial={{ opacity: 0, y: 100 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
            >
              <h6
                className="
            uppercase
            mb-4            
            text-[#fcb900] text-2xl font-bold justify-center hidden sm:block
          "
              >
                Logo
              </h6>
              <img
                src="./assets/as_logo.png"
                alt="pic"
                className="h-40 w-40 mx-auto "
              />
            </motion.div>

            <motion.div
              whileInView={{ opacity: 1, y: 0 }}
              initial={{ opacity: 0, y: 100 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className=""
            >
              <h6 className="uppercase  mb-4  justify-center text-[#fcb900] text-2xl font-bold hidden sm:block">
                Location
              </h6>

              <div className="lg:w-80 lg:h-64 w-64 h-64 mx-auto lg:ml-5">
                <GoogleMap
                  zoom={8}
                  center={{ lat: 23.694846, lng: 86.155938 }}
                  mapContainerClassName="h-full rounded-md "
                >
                  <Marker
                    className="w-24 h-24"
                    onLoad={onLoadMarker}
                    position={{ lat: 23.694846, lng: 86.155938 }}
                  />
                </GoogleMap>
              </div>
            </motion.div>

            <motion.div
              whileInView={{ opacity: 1, y: 0 }}
              initial={{ opacity: 0, y: 100 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className=""
            >
              <h6 className="uppercase  mb-4 flex justify-center  text-[#fcb900] text-2xl font-bold">
                Important links
              </h6>
              <motion.p
                whileInView={{ opacity: 1, y: 0 }}
                initial={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.55, delay: 0.55 }}
                viewport={{ once: true }}
                className="mb-4 text-xl lg:text-left lg:ml-20 uppercase"
              >
                <a
                  href="https://sail.co.in/"
                  target="blank"
                  className="text-white"
                >
                  Sail
                </a>
              </motion.p>
              <motion.p
                whileInView={{ opacity: 1, y: 0 }}
                initial={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.65, delay: 0.65 }}
                viewport={{ once: true }}
                className="mb-4 text-xl lg:text-left lg:ml-20 uppercase"
              >
                <a
                  href="http://cbse.nic.in/newsite/index.html"
                  target="blank"
                  className="text-white"
                >
                  CBSE
                </a>
              </motion.p>
              <motion.p
                whileInView={{ opacity: 1, y: 0 }}
                initial={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.75, delay: 0.75 }}
                viewport={{ once: true }}
                className="mb-4 text-xl lg:text-left lg:ml-20 uppercase"
              >
                <a
                  href="https://bokaro.nic.in/"
                  target="blank"
                  className="text-white"
                >
                  Bokaro District
                </a>
              </motion.p>
              <motion.p
                whileInView={{ opacity: 1, y: 0 }}
                initial={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.85, delay: 0.85 }}
                viewport={{ once: true }}
                className="mb-4 text-xl lg:text-left lg:ml-20 uppercase"
              >
                <a
                  href="https://www.jharkhand.gov.in/"
                  target="blank"
                  className="text-white"
                >
                  Jharkhand Government
                </a>
              </motion.p>
            </motion.div>
            <motion.div
              whileInView={{ opacity: 1, y: 0 }}
              initial={{ opacity: 0, y: 100 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className=""
            >
              <h6 className="uppercase  mb-4 flex justify-center  text-[#fcb900] text-2xl font-bold ">
                Contact
              </h6>
              <motion.div
                whileInView={{ opacity: 1, y: 0 }}
                initial={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.45, delay: 0.45 }}
                viewport={{ once: true }}
                className=" flex  mb-4 text-xl text-center  mx-auto text-white"
              >
                <div className="  w-1/3 ">
                  <div className=" flex justify-end mr-4">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="envelope"
                      className="w-6 "
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="currentColor"
                        d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="text-left w-2/3">66265@cbseshiksh.in</div>
              </motion.div>

              <motion.div
                whileInView={{ opacity: 1, y: 0 }}
                initial={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.55, delay: 0.55 }}
                viewport={{ once: true }}
                className=" flex  mb-4 text-xl text-center  mx-auto text-white"
              >
                <div className="  w-1/3 ">
                  <div className=" flex justify-end mr-4">
                    <img
                      src="../assets/phone-call-icon.png"
                      alt="pic"
                      className="w-6 h-6 mt-3"
                    />
                  </div>
                </div>
                <motion.div
                  whileInView={{ opacity: 1, y: 0 }}
                  initial={{ opacity: 0, y: 100 }}
                  transition={{ duration: 0.65, delay: 0.65 }}
                  viewport={{ once: true }}
                  className="text-left w-2/3"
                >
                  +91 9430104439, <br />
                  +91 8986875341
                </motion.div>
              </motion.div>
              <motion.div
                whileInView={{ opacity: 1, y: 0 }}
                initial={{ opacity: 0, y: 100 }}
                transition={{ duration: 0.75, delay: 0.75 }}
                viewport={{ once: true }}
                className=" flex  mb-4 text-xl text-center  mx-auto text-white"
              >
                <div className="  w-1/3 ">
                  <div className=" flex justify-end mr-4">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="print"
                      className="w-6"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="currentColor"
                        d="M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="text-left w-2/3"> 06542-240227</div>
              </motion.div>
            </motion.div>
          </div>
        </div>
        <motion.div
          whileInView={{ opacity: 1, y: 0 }}
          initial={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.75, delay: 0.75 }}
          viewport={{ once: true }}
          className="text-center font-bold p-6 bg-white"
        >
          <span className="text-black">© 2022 - </span>
          <a
            className="text-black text-lg font-bold hover:text-blue-300 "
            href="/#"
          >
            BISSS-8B
          </a>
          <span className="text-black">
            , Education Department, Bokaro Steel Plant
          </span>
        </motion.div>
      </footer>
    </React.Fragment>
  );
};
export default HomePage;
